import { render, staticRenderFns } from "./ai-assistant.vue?vue&type=template&id=c921aa54&scoped=true"
import script from "./ai-assistant.vue?vue&type=script&lang=js"
export * from "./ai-assistant.vue?vue&type=script&lang=js"
import style0 from "./ai-assistant.vue?vue&type=style&index=0&id=c921aa54&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c921aa54",
  null
  
)

export default component.exports